let activeCommitteeScope: string | undefined

export const setCommitteeScope = (id?: string) => {
  activeCommitteeScope = id
}

export const getCommitteeScope = () => activeCommitteeScope
